// src/components/Hero.tsx

import { ArrowRight } from "lucide-react";

import { motion } from "framer-motion";

import { useState } from "react";

import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";

import hero from "../assets/hero.png";
import hero1 from "../assets/womenmachine.png";
import hero2 from "../assets/fitness-girl.png";

import DemoModal from "./DemoModal";

import "./Hero.css";


const slides = [

  {
    badge:"SMART PROTEIN TECHNOLOGY",

    title:
      <>
        Smart Protein
        <span> Vending </span>
        For Modern Fitness
      </>,

    desc:
      "Dagda installs and manages smart protein vending machines in your gym, office or campus, giving members on-demand whey, creatine, collagen and BCAA drinks while creating a new revenue stream and a better wellness experience without extra staffing.",

    image:hero1,
  },

  {
    badge:"NEXT GEN FITNESS",

    title:
      <>
        Fresh Nutrition
        <span> Anytime </span>
        Anywhere
      </>,

    desc:
      "Dagda is a smart vending machine inside your gym that prepares fresh protein and performance drinks in 60 seconds so you can walk in from work or college with no tubs, no shakers and no leaks in your bag.",

    image:hero,
  },

  {
    badge:"WHY DAGDA",

    title:
      <>
        Protein Innovation
        <span> Built </span>
        For Performance
      </>,

    desc:
      "Dagda is a smart protein vending machine that prepares fresh whey, creatine, collagen and BCAA drinks in just 60 seconds, making essential workout nutrition always just a tap away.",

    image:hero2,
  },

];

/* =========================
   RESPONSIVE
========================= */

const responsive = {

  desktop:{
    breakpoint:{
      max:3000,
      min:0
    },
    items:1
  }

};

const Hero = () => {

  const [openModal, setOpenModal] =
    useState(false);

  return (

    <>

      <section
        id="home"
        className="hero"
      >

        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={7000}
          transitionDuration={1600}
          arrows={false}
          showDots={true}
          draggable={true}
          swipeable={true}
          keyBoardControl={true}
          pauseOnHover={false}
          customTransition="
            transform 1600ms cubic-bezier(0.22, 1, 0.36, 1)
          "
          containerClass="hero-carousel"
          dotListClass="hero-dots"
        >

          {slides.map((slide,index)=>(

            <div
              className="hero-slide-wrapper"
              key={index}
            >

              {/* LEFT */}

              <div className="hero-left">

                <motion.div
                  initial={{
                    opacity:0,
                    y:20
                  }}
                  whileInView={{
                    opacity:1,
                    y:0
                  }}
                  transition={{
                    duration:1
                  }}
                  className="hero-badge"
                >

                  {slide.badge}

                </motion.div>

                <motion.div
                  initial={{
                    opacity:0,
                    x:-50
                  }}
                  whileInView={{
                    opacity:1,
                    x:0
                  }}
                  transition={{
                    duration:1.2
                  }}
                >

                  <h1>
                    {slide.title}
                  </h1>

                  <p>
                    {slide.desc}
                  </p>

                </motion.div>

                <motion.div
                  initial={{
                    opacity:0,
                    y:20
                  }}
                  whileInView={{
                    opacity:1,
                    y:0
                  }}
                  transition={{
                    duration:1.3
                  }}
                  className="hero-buttons"
                >

                  <button
                    className="primary-btn"
                    onClick={() => setOpenModal(true)}
                  >

                    Book a Demo

                    <ArrowRight size={18} />

                  </button>

                </motion.div>

              </div>

              {/* RIGHT */}

              <div className="hero-right">

                <motion.div
                  className="person-wrapper-hero"
                  initial={{
                    opacity:0,
                    x:80,
                    scale:0.9
                  }}
                  whileInView={{
                    opacity:1,
                    x:0,
                    scale:1
                  }}
                  transition={{
                    duration:1.4
                  }}
                >

                  <div className="orange-shape"></div>

                  <div className="small-circle one"></div>

                  <div className="small-circle two"></div>

                  {/* IMAGE POSITION */}

                  <div
                    className={`image-position image-${index + 1}`}
                  >

                    <img
                      src={slide.image}
                      alt="Fitness"
                      className="person-image-hero"
                    />

                  </div>

                </motion.div>

              </div>

            </div>

          ))}

        </Carousel>

      </section>

      {/* MODAL */}

      <DemoModal
        open={openModal}
        onClose={() => setOpenModal(false)}
      />

    </>

  );
};

export default Hero;